module.exports = __webpack_public_path__ + "Banner_TranquilTeachings-ac909f3d97059216a2181fa046c5bdd1.svg";